<template>
    <div>


            <swiper class="item_wrap" ref="swiper" :options="swiperOption" @click="onClick"
                    @slideChange="slideChange">
                <swiper-slide class="user_item" v-for="(data,index) in itemData" :key="`itemSwiper${index}`">
                    <div class="img_wrap">
                        <img :src="returnThumbnail(data)" :id="`userItem${data.i_sku}`">
                    </div>
                </swiper-slide>
            </swiper>

    </div>

</template>

<script>
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import 'swiper/css/swiper.css'
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";
import imageResizeMixins from "@/mixins/imageResizeMixins";

export default {
    name: "ItemListUserItemLayout",
    mixins: [imageOption, imageResizeMixins],
    components: {
        Swiper,
        SwiperSlide,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {
        itemData: {},
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 1.77,
                spaceBetween: 3,
                grabCursor: true,
            }
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        returnThumbnail(data) {
            if (!util.isEmpty(data.ItemFile) && !util.isEmpty(data.ItemFile.Item)) {
                // return `${data.ItemFile.Item[0].org_url}?${this.setImageOptions(285, null, null)}`;
                return this.setFitWidthImg(data.ItemFile.Item, 285)
            }
        },
        moveDetail(data) {
            if (data.i_idx === Number(this.$route.params.idx)) {
                return false
            }
            if (data.im_status === 2 || data.im_status === 5 || data.im_status === 8) {
                this.$router.replace(`/premiummarket/${data}?tab=item`);
                this.$router.go();
            } else {
                this.$router.replace(`/openmarket/${data}?tab=item`);
                this.$router.go();
            }
        },

        slideChange() {
            this.slideIndex = this.$refs.swiper.$swiper.realIndex;
        },
        onClick(event) {
            if (util.isEmpty(event.target)) {
                return false;
            }
            let element = event.target;
            let elementId = element.id;
            if (util.isEmpty(elementId) || elementId.indexOf('userItem')) {
                return false;
            }
            let elementIdx = elementId.replace('userItem', "");
            console.log(elementIdx)
            this.moveDetail(elementIdx);
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
